import React from 'react'
import PropTypes from 'prop-types'

const Layout = ({ header, children }) => (
  <div>
    <div>{header}</div>
    <div>{children}</div>
  </div>
)

Layout.propTypes = {
  header: PropTypes.node,
  children: PropTypes.node,
}

Layout.defaultProps = {
  header: null,
  children: null,
}

export default Layout
